import {call, put, takeLatest} from "redux-saga/effects";
import {toast} from "react-toastify";
import * as actions from "../action.constants";
import {requestInventoryReportsAsync} from "../AsyncActions/inventoryReports.async";
import {saveInventoryReports} from "../Actions/inventoryReports.action";

function* getInventoryReports(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(requestInventoryReportsAsync, pageUrl);
    if (response?.data) {
      yield put(saveInventoryReports(response?.data));
    }
  } catch (e) {
    toast.error(e);
  }
}

export function* inventoryReportsSaga() {
  yield takeLatest(actions.REQUEST_INVENTORY_REPORTS, getInventoryReports);
}
